export default __webpack_public_path__ + "static/media/red-tex.b03e5acb.jpg";